import { render, staticRenderFns } from "./updateall.vue?vue&type=template&id=4fd06e6f&scoped=true"
import script from "./updateall.vue?vue&type=script&lang=js"
export * from "./updateall.vue?vue&type=script&lang=js"
import style0 from "./updateall.vue?vue&type=style&index=0&id=4fd06e6f&prod&scoped=true&lang=css"
import style1 from "./updateall.vue?vue&type=style&index=1&id=4fd06e6f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd06e6f",
  null
  
)

export default component.exports